import React from "react";
import "./Column.scss";

export const Column = React.forwardRef(
  ({ children, customClass, marginCustom, ...otherProps }, ref) => {
    return (
      <div
        ref={ref}
        className={`column-container ${customClass}`}
        {...otherProps}
      >
        <div
          className="column"
          style={marginCustom && { margin: marginCustom }}
        >
          {children}
        </div>
      </div>
    );
  }
);
